import React, { KeyboardEvent } from 'react'
import classNames from 'classnames'

interface IProps {
    placeholder?: string;
    name?: string;
    className?: string;
    value?: any;
    type?: string,
    required?: boolean,
    autoFocus?: boolean,
    onChange: any,
    onBlur?: any;
    id?: string,
    readOnly?: boolean,
    checked?: boolean,
    error?: string;
    disabled?:boolean;
    label?: string;
    onKeyPress?: any;
}

const TextInput = (props: IProps) => {
    const {
        className = 'form-control',
        autoFocus = false,
        required = false,
        value="",
        type,
        name,
        placeholder,
        onChange,
        onBlur,
        id,
        readOnly,
        checked,
        error,
        onKeyPress,
        ...rest
    } = props;


    return (
        <>
            <input
                type={type}
                name={name}
                readOnly={readOnly}
                autoComplete={"off"}
                className={classNames(className,{'error-field': error})}
                placeholder={placeholder}
                required={required}
                autoFocus={autoFocus}
                value={value || ''}
                onChange={onChange}
                onBlur={onBlur}
                onKeyPress={onKeyPress}
                id={id}
                checked={checked}
                {...rest}
            />
            {error &&
                <div className="text-danger">
                    {error}
                </div>
            }
        </>
    )
}

export default TextInput
